export class AddCommentServiceConstants {
    static url = {
        postEmailUrl: "api/v2/RequestComment/GenerateEmail"
    };
    static COMPONENT_NAME = "Add Comment Service";
}
